import { CreateOrderResponse } from '@dgx-pr-spa/shared/util';
import { createReducer, on } from '@ngrx/store';
import * as fromCreateOrder from '../actions/create.order.action';
import { StateSlice } from '@core/helpers/state-slice';

export type CreateOrderState = StateSlice<CreateOrderResponse>;

export const initialState: CreateOrderState = {
  data: {} as CreateOrderResponse,
  loaded: false,
  loading: false,
  error: null,
};

const createOrderReducer = createReducer(
  initialState,
  on(fromCreateOrder.loadCreateOrder, (state, { payload }) => ({
    ...initialState,
    loading: payload?.showFullLoader ?? false,
  })),
  on(fromCreateOrder.loadCreateOrderSuccess, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      loading: false,
      loaded: true,
    };
  }),
  on(fromCreateOrder.loadCreateOrderFail, (_, { payload }) => {
    return {
      ...initialState,
      error: payload,
    };
  }),
  on(fromCreateOrder.resetCreateOrder, () => {
    return {
      ...initialState,
    };
  })
);

export function reducer(
  state: CreateOrderState | undefined,
  action: fromCreateOrder.CreateOrderActions
) {
  return createOrderReducer(state, action);
}
